import { ElementType } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import Radio from '@mui/material/Radio';
import LinearProgress from '@mui/material/LinearProgress';

export const MessageBubble = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  maxWidth: '414px',
  padding: theme.spacing(2, 3),
  borderRadius: '16px',
  backgroundColor: theme.palette.neutrals.beige2
}));

export const MessageText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1R,
  color: theme.palette.brand.darkGreen
}));

export const LoadingProgress = styled(LinearProgress)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  height: '4px',
  backgroundColor: theme.palette.brand.lightGreen,
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.brand.mediumGreen
  }
}));

export const ReasonList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '414px',
  overflow: 'hidden',
  borderRadius: '16px',
  backgroundColor: theme.palette.neutrals.beige2
}));

export const ReasonMessage = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1R,
  padding: '12px 24px',
  color: theme.palette.brand.darkGreen,
  lineHeight: 1.4
}));

export const ReasonMessageHighlight = styled('strong')(({ theme }) => ({
  ...theme.typography.body1B
}));

export const ScheduleCancelContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  width: '100%'
});

export const ReasonItem = styled(ButtonBase)<{ component?: ElementType }>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '16px',
  width: '100%',
  minHeight: '56px',
  padding: '8px 24px',
  textAlign: 'left',
  // divisor recuado 24px de cada lado, como no Figma
  '& + &::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '24px',
    right: '24px',
    height: '1px',
    backgroundColor: theme.palette.neutrals.beige3
  },
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: theme.palette.neutrals.beige3
  },
  '&.Mui-disabled': {
    cursor: 'default'
  }
}));

export const ReasonRadio = styled(Radio)(({ theme }) => ({
  padding: '12px',
  color: theme.palette.neutrals.beige4,
  '&.Mui-checked': {
    color: theme.palette.brand.darkGreen
  },
  '&.Mui-disabled': {
    color: theme.palette.neutrals.beige4
  },
  '&.Mui-checked.Mui-disabled': {
    color: theme.palette.brand.darkGreen
  }
}));

export const ReasonLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1R,
  flex: 1,
  color: theme.palette.brand.darkGreen
}));

export const ErrorBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px'
});

export const ErrorText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2B,
  lineHeight: 1.2,
  color: theme.palette.error.main
}));
